import { create } from "zustand";
import { persist } from "zustand/middleware";
import intl from "../i18n/messages";

const useLangStore = create(
  persist(
    (set) => {
      const [messages, localeLang] = intl.getBaseLang("es");

      return {
        locale: localeLang,
        messages,

        changeLang: (newLocale) => {
          const [newMessages, newLocaleLang] = intl.getBaseLang(newLocale);

          set({
            locale: newLocaleLang,
            messages: newMessages,
          });
        },
      };
    },
    {
      name: "app-language",
      partialize: (state) => ({
        locale: state.locale,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.locale) {
          const [messages, localeLang] = intl.getBaseLang(state.locale);

          state.locale = localeLang;
          state.messages = messages;
        }
      },
    },
  ),
);

export default useLangStore;
